import { render, staticRenderFns } from "./Opera.vue?vue&type=template&id=7b6dceee&scoped=true&"
import script from "./Opera.vue?vue&type=script&lang=js&"
export * from "./Opera.vue?vue&type=script&lang=js&"
import style0 from "./Opera.vue?vue&type=style&index=0&id=7b6dceee&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6dceee",
  null
  
)

export default component.exports